const people = [
    {
      id: 1,
      image:
        'https://prayashniraula.netlify.app/photos/colorpic.jpg',
      name: 'Prayash Niraula',
      title: 'Graphic Designer',
      quote:
        ' At first I was unsure whether to go to him or not but I am glad I did.',
    },
    {
      id: 2,
      image:
        'https://pbs.twimg.com/profile_images/492943290652573697/0QMljZ86_400x400.jpeg',
      name: 'Sagar Pyakurel',
      title: 'Content Writer',
      quote:
        'A very talented and creative person who never fails to impress us with his services. I am more than happy with the result I am getting.',
    },
    {
      id:3,
      image:'https://www.digitalpravidhi.com/img/bhawesh.png',
      name:'Bhawesh Kafle',
      title:'CEO',
      quote:'Really hard working with friendly assistance 24*7 and happy with the service I am getting.'
    }
    
  ];
  
  export default people;